
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateMissingReferredProjectDeliverable200Response,
  CreateMissingReferredProjectDeliverableRequest,
} from '../models';
import {
    CreateMissingReferredProjectDeliverable200ResponseFromJSON,
    CreateMissingReferredProjectDeliverable200ResponseToJSON,
    CreateMissingReferredProjectDeliverableRequestFromJSON,
    CreateMissingReferredProjectDeliverableRequestToJSON,
} from '../models';

export interface CreateMissingReferredProjectDeliverableOperationRequest {
    referralId: string;
    createMissingReferredProjectDeliverableRequest: CreateMissingReferredProjectDeliverableRequest;
}

/**
 * 
 */
export class BusinessReferralAdminApi extends runtime.BaseAPI {

    /**
     * Admin can create a missing deliverable lot for a BRP
          */
    async createMissingReferredProjectDeliverableRaw(requestParameters: CreateMissingReferredProjectDeliverableOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CreateMissingReferredProjectDeliverable200Response>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling createMissingReferredProjectDeliverable().'
            );
        }

        if (requestParameters['createMissingReferredProjectDeliverableRequest'] == null) {
            throw new runtime.RequiredError(
                'createMissingReferredProjectDeliverableRequest',
                'Required parameter "createMissingReferredProjectDeliverableRequest" was null or undefined when calling createMissingReferredProjectDeliverable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<CreateMissingReferredProjectDeliverable200Response>({
            path: `/business-referral/api/admin/{referralId}/create-missing-deliverable`.replace(`{${"referralId"}}`, encodeURIComponent(String(requestParameters['referralId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMissingReferredProjectDeliverableRequestToJSON(requestParameters['createMissingReferredProjectDeliverableRequest']),
        }, initOverrides);

        if (response._data) { response._data=CreateMissingReferredProjectDeliverable200ResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Admin can create a missing deliverable lot for a BRP
          */
    async createMissingReferredProjectDeliverable(requestParameters: CreateMissingReferredProjectDeliverableOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CreateMissingReferredProjectDeliverable200Response> {
        const response = await this.createMissingReferredProjectDeliverableRaw(requestParameters, initOverrides);
        return response._data;
    }

}
